import axios from "axios";
import { LocalStorageConstants } from "../../src/Core/Common/Constants";
import { AppThunkAction } from "../store";
import {
    STORE_USER,
    USER_SIGNED_OUT,
    USER_EXPIRED,
    STORE_USER_ERROR,
    LOADING_USER,
    RECEIVED_SESSION_IDLE_MINUTES,
    SIGN_IN_PAGE_LOADED,
    SIGN_OUT
} from "../types/authTypes";
import { RequestSource } from "../../src/Core/Common/Enums";
import { User } from "oidc-client";

export function userRenewed(user: User) {
    localStorage.setItem(LocalStorageConstants.USER_ID, user.profile.user_id);

    return {
        type: STORE_USER,
        payload: user,
    };
}

export function userSignedIn(user: User) {
    localStorage.setItem(LocalStorageConstants.USER_ID, user.profile.user_id);

    return {
        type: STORE_USER,
        payload: user,
    };
}

export function loadingUser() {
    return {
        type: LOADING_USER,
    };
}

export function signInPageLoaded() {
    return {
        type: SIGN_IN_PAGE_LOADED,
    };
}

export function storeUserError(errorDesc?: string) {
    return {
        type: STORE_USER_ERROR,
        payload: errorDesc
    };
}

export function userExpired() {
    return {
        type: USER_EXPIRED,
    };
}

export function userSignedOut() {
    return {
        type: USER_SIGNED_OUT,
    };
}

export function signOut() {
    return {
        type: SIGN_OUT,
    };
}

export const requestSessionIdleMinutes =
    (callback?: (data) => void): AppThunkAction<any> =>
        dispatch => {
            axios.get(`${process.env.REACT_APP_API_URL}/api/KeyVault/GetSessionTimeOutMinutes?requestSource=${RequestSource.WebAddIn}`).then(response => {
                const data = response.data;
                dispatch({
                    type: RECEIVED_SESSION_IDLE_MINUTES,
                    payload: data,
                });
                if (callback) {
                    callback(data);
                }
            });
        };

export const updateLogoutDate = async () => {
    await axios.put(`${process.env.REACT_APP_API_URL_SUITE}/api/login-history/update-logout-date`).catch(error => {
        //should or will be removed when there is logger implementation
        console.log(`updateLogoutDate API failed with error ${error}`);
    });
};